<template>
  <div :id="mainId" class="al-loading" test-id="al-loading" :class="[sizeLoading]">
    <div class="al-loading-wrapper">
      <div class="al-loading-wrapper-spinner">
        <div class="al-loading-wrapper-spinner-content">
          <span class="loading-gradient-spinner" aria-label="loading"></span>
        </div>
      </div>
      <div v-if="message || otherMessage" class="al-loading-wrapper-message">
        <div v-if="message" class="al-loagin-wrapper-message-1">
          {{ message }}
        </div>
        <div v-if="otherMessage" class="al-loagin-wrapper-message-2">
          {{ otherMessage }}
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'AlLoading',
  // -------------------------------------------------
  // + Life Cicle
  // -------------------------------------------------
  components: {},
  props: {
    /**
     * Element Identify
     */
    size: {
      type: String,
      default: null
    },
    message: {
      type: String,
      default: null
    },
    otherMessage: {
      type: String,
      default: null
    }
  },
  data() {
    return {};
  },
  computed: {
    mainId() {
      // eslint-disable-next-line no-underscore-dangle
      const id = this.id ? this.id : this._uid;
      return `loading-${id}`;
    },
    sizeLoading() {
      return this.size ? `is-${this.size}` : null;
    }
  },
  methods: {}
};
</script>

<style lang="scss">
/**
 * Variables
 */
$color-spinner: #009865;

$w-spinner-container: 60px;
$h-spinner-containe: $w-spinner-container;
$w-spinner: 48px;
$h-spinner: $w-spinner;
$br-spinner: $h-spinner;
$w-stroke: 12px;
$w-stroke-fill: 100% - ($w-stroke * 100% / $w-spinner);

$w-spinner-sm-container: 32px;
$h-spinner-sm-containe: $w-spinner-sm-container;
$w-spinner-sm: 24px;
$h-spinner-sm: $w-spinner-sm;
$br-spinner-sm: $h-spinner-sm;
$w-stroke-sm: 8px;
$w-stroke-fill-sm: 100% - ($w-stroke-sm * 100% / $w-spinner-sm);

$w-spinner-xs-container: 24px;
$h-spinner-xs-containe: $w-spinner-xs-container;
$w-spinner-xs: 18px;
$h-spinner-xs: $w-spinner-xs;
$br-spinner-xs: $h-spinner-xs;
$w-stroke-xs: 6px;
$w-stroke-fill-xs: 100% - ($w-stroke-xs * 100% / $w-spinner-xs);

$mt-message: 8px;
$font-size-message: 16px;
$font-color-message: #9b9f9f;

.al-loading {
  .al-loading-wrapper {
    align-items: center;
    display: flex;
    flex-direction: column;

    .al-loading-wrapper-spinner {
      align-items: center;
      display: flex;
      height: $h-spinner-containe;
      justify-content: center;
      width: $w-spinner-container;

      .al-loading-wrapper-spinner-content {
        height: $h-spinner;
        width: $w-spinner;
      }
    }
  }

  .al-loading-wrapper-message {
    color: $font-color-message;
    font-size: $font-size-message;
    line-height: 20px;
    margin-top: $mt-message;
    padding: 0 20px;
    text-align: center;
  }

  .loading-gradient-spinner {
    border-radius: $br-spinner;
    height: $h-spinner;
    width: $w-spinner;

    &::before {
      border-radius: 0 $br-spinner $br-spinner 0;
      height: $h-spinner;
    }

    &::after {
      border-radius: $w-stroke-fill;
      height: $w-stroke-fill;
      width: $w-stroke-fill;
    }
  }

  .loading-gradient-spinner {
    animation: spinAnimation 0.675s linear infinite forwards;
    animation: spinAnimation 0.675s linear infinite forwards;
    background: rgba(lightgray, 0.5);
    background-color: #f5f8f7;
    display: block;

    position: relative;

    &::before,
    &::after {
      content: '';
      display: block;
      position: absolute;
    }

    &::before {
      background: transparent;
      background-image: linear-gradient(transparent, $color-spinner);
      right: 0;
      top: 0;
      width: 50%;
      z-index: 1;
    }

    &::after {
      background: white;
      left: 50%;
      top: 50%;
      transform: translate(-50%, -50%);
      z-index: 1;
    }
  }

  &.is-sm {
    .al-loading-wrapper-spinner {
      height: $h-spinner-sm-containe;
      width: $w-spinner-sm-container;

      .al-loading-wrapper-spinner-content {
        height: $h-spinner-sm;
        width: $w-spinner-sm;
      }
    }

    .loading-gradient-spinner {
      border-radius: $br-spinner-sm;
      height: $h-spinner-sm;
      width: $w-spinner-sm;

      &::before {
        border-radius: 0 $br-spinner-sm $br-spinner-sm 0;
        height: $h-spinner-sm;
      }

      &::after {
        border-radius: $w-stroke-fill-sm;
        height: $w-stroke-fill-sm;
        width: $w-stroke-fill-sm;
      }
    }
  }

  &.is-xs {
    .al-loading-wrapper-spinner {
      height: $h-spinner-xs-containe;
      width: $w-spinner-xs-container;

      .al-loading-wrapper-spinner-content {
        height: $h-spinner-xs;
        width: $w-spinner-xs;
      }
    }

    .loading-gradient-spinner {
      border-radius: $br-spinner-xs;
      height: $h-spinner-xs;
      width: $w-spinner-xs;

      &::before {
        border-radius: 0 $br-spinner-xs $br-spinner-xs 0;
        height: $h-spinner-xs;
      }

      &::after {
        border-radius: $w-stroke-fill-xs;
        height: $w-stroke-fill-xs;
        width: $w-stroke-fill-xs;
      }
    }
  }
}

@keyframes spinAnimation {
  to {
    transform: rotate(360deg);
  }
}

@keyframes spinAnimation {
  to {
    transform: rotate(360deg);
  }
}
</style>
